<model-viewer *ngIf="iosSrc" #modelViewer id="model-viewer"
  [attr.src]="src" 
  [attr.iosSrc]="iosSrc"
  ar="" 
  [attr.ar-placement]="placement" 
  ar-modes="webxr quick-look scene-viewer" camera-controls="" 
  alt="A 3D model of an astronaut" enable-pan ar-status="not-presenting">
  <div id="lazy-load-poster" slot="poster"></div>

</model-viewer>

<model-viewer *ngIf="!iosSrc" #modelViewer id="model-viewer"
  [attr.src]="src" 
  ar="" 
  [attr.ar-placement]="placement" 
  ar-modes="webxr quick-look scene-viewer" camera-controls="" 
  alt="A 3D model of an astronaut" enable-pan ar-status="not-presenting">
  <div id="lazy-load-poster" slot="poster"></div>

</model-viewer>